import { Injectable, InjectionToken } from '@angular/core'
import { RequestServices } from '@services/request.services'
import * as moment from 'moment'
import { AuthHelper } from '@helpers/auth.helper'
import MainConfig from '../../config/main'

@Injectable()
export class ConfigService {
    private responseConfig: any
    private commonSetting: any
    private behaviorSetting: any
    private timelineForms: any

    config: Config
    lastReload = null

    constructor(private requestServices: RequestServices) {
    }

    load() {
        // if (!AuthHelper.getUser()) {
        //     return
        // }
        // if (this.lastReload && moment.duration(moment().diff(this.lastReload)).asMinutes() < 1) {
        //     return
        // }
        this.lastReload = moment()
        console.log('AppInitService.init() called')
            const resourceUrl = 'resource'
            const resourceData = {
                actions: [],
                status: {
                    clinic: {
                        paths: {
                            '{}': true,
                        },
                    },
                    setting: {
                        map: {
                            common: true,
                        },
                        paths: {
                            '{}': true,
                        },
                    },
                    staff: {
                        paths: {
                            '{"roles":"cordinator"}': true,
                            '{"roles":"doctor"}': true,
                            '{}': true,
                        },
                    },
                },
            }
            this.requestServices.httpPost(resourceUrl, resourceData).subscribe(data => {
                let staffs = data['response']['staff'] ? data['response']['staff']['paths']['{}'] : []
                let clinics = data['response']['clinic'] ? data['response']['clinic']['paths']['{}'] : []
                this.initConfig(data['response']['setting'], staffs, clinics)
                // resolve()
            }, err => {
                console.error(err)
                // resolve()
            })
        // return new Promise<any>((resolve, reject) => {
        //     console.log('AppInitService.init() called')
        //     const resourceUrl = 'resource'
        //     const resourceData = {
        //         actions: [],
        //         status: {
        //             clinic: {
        //                 paths: {
        //                     '{}': true,
        //                 },
        //             },
        //             setting: {
        //                 map: {
        //                     common: true,
        //                 },
        //                 paths: {
        //                     '{}': true,
        //                 },
        //             },
        //             staff: {
        //                 paths: {
        //                     '{"roles":"cordinator"}': true,
        //                     '{"roles":"doctor"}': true,
        //                     '{}': true,
        //                 },
        //             },
        //         },
        //     }
        //     this.requestServices.httpPost(resourceUrl, resourceData).subscribe(data => {
        //         let staffs = data['response']['staff'] ? data['response']['staff']['paths']['{}'] : []
        //         let clinics = data['response']['clinic'] ? data['response']['clinic']['paths']['{}'] : []
        //         this.initConfig(data['response']['setting'], staffs, clinics)
        //         resolve()
        //     }, err => {
        //         console.error(err)
        //         resolve()
        //     })
        // })
    }

    get(): Config {
        return this.config
    }

    initConfig(responseConfig, staffs = [], clinics = []) {
        this.responseConfig = responseConfig
        this.commonSetting = responseConfig['map']['common']
        this.behaviorSetting = this.findBehaviorConfig(responseConfig['paths']['{}'])

        this.config = {
            mailSetting: {},
            clinics: clinics,
            doctors: clinics,
            staffs: staffs,
            timelineForms: this.convertTagsObject(this.behaviorSetting ? this.behaviorSetting.timelineForms : []),
            timelineTags: this.behaviorSetting ? this.behaviorSetting.noteTag : [],
            timelineNameTags: this.behaviorSetting ? this.convertTagsObject(this.behaviorSetting.noteTag) : [],
            chatTags: this.behaviorSetting ? this.behaviorSetting.chatTag : [],
            chatNameTags: this.behaviorSetting ? this.convertTagsObject(this.behaviorSetting.chatTag) : [],
            chatPrivateTags: this.behaviorSetting ? this.behaviorSetting.chatPrivateTag : [],
            messageTags: this.behaviorSetting ? this.behaviorSetting.roomMessageTag : [],
            alignerTags: this.behaviorSetting ? this.behaviorSetting.alignerStatus : [],
            enableWebsocket: MainConfig.ENABLE_WEBSOCKET,
            enableChatReply: MainConfig.ENABLE_CHAT_REPLY,
            enableChatReact: MainConfig.ENABLE_CHAT_REACTION,
        }

        console.debug('system config', this.config)
    }

    findBehaviorConfig(configPaths: any[]) {
        const optionIndex = configPaths.findIndex(i => i._id === 'option')
        return configPaths[optionIndex]
    }

    convertTagsObject(timelineForms) {
        if (timelineForms) {
            return timelineForms.reduce(function(acc, cur, i) {
                acc[cur._id] = cur.title
                return acc
            }, {})
        }
        return []
    }

    getDoctorName(doctorId) {
        if (this.config.doctors) {
            const foundIndex = this.config.doctors.findIndex(i => i._id === doctorId)
            if (foundIndex >= 0) {
                return this.config.doctors[foundIndex]['name']
            }
            return ''
        }
    }

    getDoctor(doctorId) {
        if (this.config.doctors) {
            const foundIndex = this.config.doctors.findIndex(i => i._id === doctorId)
            if (foundIndex >= 0) {
                return this.config.doctors[foundIndex]
            }
            return ''
        }
    }

    getStaffName(staff) {
        if (this.config.staffs) {
            const foundIndex = this.config.staffs.findIndex(i => i._id === staff)
            if (foundIndex >= 0) {
                const names = [this.config.staffs[foundIndex]['firstName'], this.config.staffs[foundIndex]['familyName']]
                return names.filter(i => !!i).join(' ')
            }
            return ''
        }
    }

    getStaff(staff) {
        if (this.config.staffs) {
            const foundIndex = this.config.staffs.findIndex(i => i._id === staff)
            if (foundIndex >= 0) {
                return this.config.staffs[foundIndex]
            }
            return ''
        }
    }
}

export const APP_CONFIG = new InjectionToken<ConfigService>('app.config')

export interface Config {
    mailSetting: any
    clinics: any[]
    staffs: any[]
    doctors: any[]
    timelineForms: string[]

    timelineTags: any[]
    timelineNameTags: any[]
    chatTags: any[]
    chatNameTags: any[]
    chatPrivateTags: any[]
    messageTags: any[]
    alignerTags: any[]
    enableWebsocket: boolean
    enableChatReply: boolean
    enableChatReact: boolean
}



// WEBPACK FOOTER //
// ./src/app/services/config.service.ts